import { render, staticRenderFns } from "./ThirdPartyPayment.vue?vue&type=template&id=478dbf42&scoped=true"
import script from "./ThirdPartyPayment.vue?vue&type=script&lang=js"
export * from "./ThirdPartyPayment.vue?vue&type=script&lang=js"
import style0 from "./ThirdPartyPayment.vue?vue&type=style&index=0&id=478dbf42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478dbf42",
  null
  
)

export default component.exports